import React, { forwardRef, ReactNode } from 'react';
import {
  Select as ChakraSelect,
  SelectProps,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends Omit<SelectProps, `css`> {
  children: ReactNode;
  label?: string;
  name: string;
  variant?: `withIcon` | 'proRikApp';
  disabled?: boolean
}

export const Select = forwardRef<HTMLSelectElement, Props>(
  ({ children, label, name, variant, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`Select`, { variant });
    return (
      <ChakraSelect id={name} name={name} ref={ref} sx={styles} {...props}>
        {children}
      </ChakraSelect>
    );
  }
);
export type { Props as SelectProps };
